export default "__VITE_ASSET__74c29e05__"